module.exports = __webpack_public_path__ + "assets/img/title-d23cf093.png";